import * as types from './types'
import { workLogActions } from '@/entity'

export const actions = {
	getWorkLogAction: (payload) => ({
		type: types.GET_WORKLOG_DATA,
	}),

	getWorkLogActionDone: (payload) => ({
		type: types.GET_WORKLOG_DATA_DONE,
		payload,
	}),

	getWorkLogActionFail: (payload) => ({
		type: types.GET_WORKLOG_DATA_FAIL,
	}),

	addWorkToWorkLog: (payload) => ({
		type: types.ADD_WORK_TO_WORKLOG,
		payload,
	}),

	updateWorkInWorkLog: (payload) => ({
		type: types.UPDATE_WORK_IN_WORKLOG,
		payload,
	}),

	// UI State Actions
	setActiveWorkLogOrg: (orgBin) => ({
		type: types.SET_ACTIVE_WORK_LOG_ORG,
		payload: orgBin,
	}),

	setActiveTab: (tabCode) => ({
		type: types.SET_ACTIVE_TAB,
		payload: tabCode,
	}),

	setActiveTabEmployer: (tabName) => ({
		type: types.SET_ACTIVE_TAB_EMPLOYER,
		payload: tabName,
	}),

	setSelectedCarouselDate: (date) => ({
		type: types.SET_SELECTED_CAROUSEL_DATE,
		payload: date,
	}),

	setEmployeeSelectedCarouselDate: (date) => ({
		type: types.SET_EMPLOYEE_SELECTED_CAROUSEL_DATE,
		payload: date,
	}),

	setDisabledDates: (dates) => ({
		type: types.SET_DISABLED_DATES,
		payload: dates,
	}),

	setEmployeeDisabledDates: (dates) => ({
		type: types.SET_EMPLOYEE_DISABLED_DATES,
		payload: dates,
	}),

	setSelectedEmployee: (employee) => ({
		type: types.SET_SELECTED_EMPLOYEE,
		payload: employee,
	}),

	setSearchQuery: (query) => ({
		type: types.SET_SEARCH_QUERY,
		payload: query,
	}),

	setNewlyAddedDates: (dates) => ({
		type: types.SET_NEWLY_ADDED_DATES,
		payload: dates,
	}),

	setErrorMessage: (message) => ({
		type: types.SET_ERROR_MESSAGE,
		payload: message,
	}),

	// Modal Management Actions
	setModalState: (modalName, isOpen) => ({
		type: types.SET_MODAL_STATE,
		payload: { modalName, isOpen },
	}),

	resetModalStates: () => ({
		type: types.RESET_MODAL_STATES,
	}),

	// Date Picker Actions
	setDatePickerState: (pickerName, isOpen) => ({
		type: types.SET_DATE_PICKER_STATE,
		payload: { pickerName, isOpen },
	}),

	setSelectedDate: (dateName, date) => ({
		type: types.SET_SELECTED_DATE,
		payload: { dateName, date },
	}),

	// Reset Actions
	resetEmployeeData: () => ({
		type: types.RESET_EMPLOYEE_DATA,
	}),

	resetOrgData: () => ({
		type: types.RESET_ORG_DATA,
	}),

	resetWorkLogState: () => ({
		type: types.RESET_WORKLOG_STATE,
	}),

	// Combined Actions
	addNewlyAddedDate: (date) => (dispatch, getState) => {
		const { ui } = getState().workLog
		const newDates = [...ui.newlyAddedDates, date]
		dispatch(workLogActions.setNewlyAddedDates(newDates))
	},

	addDisabledDate: (date) => (dispatch, getState) => {
		const { ui } = getState().workLog
		const isDateAlreadyExists = ui.disabledDates.some((existingDate) => {
			if (existingDate instanceof Date && typeof existingDate.getTime === 'function') {
				return existingDate.getTime() === date.getTime()
			}
			return false
		})

		if (!isDateAlreadyExists) {
			dispatch(workLogActions.setDisabledDates([...ui.disabledDates, date]))
		}
	},

	deleteWorkInWorkLogAction: (payload) => ({
		type: types.DELETE_WORK_IN_WORKLOG,
	}),

	deleteWorkInWorkLogActionDone: (payload) => ({
		type: types.DELETE_WORK_IN_WORKLOG_DONE,
		payload,
	}),

	deleteWorkInWorkLogActionFail: (payload) => ({
		type: types.DELETE_WORK_IN_WORKLOG_FAIL,
	}),

	deleteDayAction: (payload) => ({
		type: types.DELETE_DAY_ACTION,
	}),

	deleteDayActionDone: (payload) => ({
		type: types.DELETE_DAY_ACTION_DONE,
		payload,
	}),

	deleteDayActionFail: (payload) => ({
		type: types.DELETE_DAY_ACTION_FAIL,
	}),

	// Employer: этап 1 — список активных сотрудников
	getActiveEmployeeListAction: () => ({
		type: types.GET_ACTIVE_EMPLOYEE_LIST,
	}),

	getActiveEmployeeListActionDone: (payload) => ({
		type: types.GET_ACTIVE_EMPLOYEE_LIST_DONE,
		payload,
	}),

	getActiveEmployeeListActionFail: () => ({
		type: types.GET_ACTIVE_EMPLOYEE_LIST_FAIL,
	}),

	// Employer: этап 2 — список уволенных сотрудников
	getFiredEmployeeListAction: () => ({
		type: types.GET_FIRED_EMPLOYEE_LIST,
	}),

	getFiredEmployeeListActionDone: (payload) => ({
		type: types.GET_FIRED_EMPLOYEE_LIST_DONE,
		payload,
	}),

	getFiredEmployeeListActionFail: () => ({
		type: types.GET_FIRED_EMPLOYEE_LIST_FAIL,
	}),

	// Employer: этап 3 — даты сотрудника
	getEmployeeDatesAction: () => ({
		type: types.GET_EMPLOYEE_DATES,
	}),

	getEmployeeDatesActionDone: (payload) => ({
		type: types.GET_EMPLOYEE_DATES_DONE,
		payload,
	}),

	getEmployeeDatesActionFail: () => ({
		type: types.GET_EMPLOYEE_DATES_FAIL,
	}),

	// Employer: этап 4 — работы за дату
	getWorkByDateAction: () => ({
		type: types.GET_WORK_BY_DATE,
	}),

	getWorkByDateActionDone: (payload) => ({
		type: types.GET_WORK_BY_DATE_DONE,
		payload,
	}),

	getWorkByDateActionFail: () => ({
		type: types.GET_WORK_BY_DATE_FAIL,
	}),

	getCompanyAllowedAction: (payload) => ({
		type: types.COMPANY_ALLOWED,
	}),

	getCompanyAllowedActionDone: (payload) => ({
		type: types.COMPANY_ALLOWED_DONE,
		payload,
	}),

	getCompanyAllowedActionFail: (payload) => ({
		type: types.COMPANY_ALLOWED_FAIL,
	}),
}
